export default __webpack_public_path__ + "static/media/sculptures.9d33491b.jpeg";